import { useEffect, useState } from 'react'
import CrudPage from '../../components/CrudPage'
import { serviciosCrud, getTiposImpuesto } from '../../api/entities'
import { idOf } from '../../api/crud'

// ABM Servicios. Lectura: GET /servicios?view=BaseList&search=or(descripcion).
// VALIDADO EN VIVO contra el MT (2026-06-25, admin_fvv):
//   `tipoImpuesto` es @NotNull -> POST sin él devuelve 400 [PROPERTY][tipoImpuesto][must not be null].
//   ALTA  POST /servicios { descripcion, tipoImpuesto:{id}, controlarcentrocostos } -> HTTP 200
//          (persiste id 246).
//   EDICIÓN PUT /servicios/{id} (mismo payload, id en URL) -> HTTP 200.
//   Catálogo IVA: GET /tipoimpuestos?view=BaseList (EXENTO, IVA 10%, IVA 5%).
//   NOTA: la entidad NO tiene `precioVenta` (no está en la vista ni se acepta) — se eliminó;
//   el precio del servicio se gestiona por otro flujo (listas de precio), no en este ABM.
export default function ServiciosPage() {
  const [impuestos, setImpuestos] = useState([])
  useEffect(() => { getTiposImpuesto().then(setImpuestos).catch(() => {}) }, [])

  return (
    <CrudPage
      title="Servicios"
      api={serviciosCrud}
      searchPlaceholder="Buscar por descripción (mín. 3 letras)"
      columns={[
        { key: 'descripcion', label: 'Descripción' },
        { key: 'tipoImpuesto.descripcion', label: 'IVA' },
        { key: 'controlarcentrocostos', label: 'Centro de costos', render: (r) => (r.controlarcentrocostos ? 'Sí' : 'No') },
      ]}
      fields={[
        { name: 'descripcion', label: 'Descripción', required: true, full: true },
        { name: 'tipoImpuesto', label: 'IVA', type: 'select', options: impuestos, required: true },
        { name: 'controlarcentrocostos', label: 'Controlar centro de costos', type: 'checkbox', full: true },
      ]}
      toPayload={(f) => ({
        descripcion: f.descripcion,
        tipoImpuesto: idOf(f.tipoImpuesto),
        controlarcentrocostos: !!f.controlarcentrocostos,
      })}
      fromEntity={(e) => ({
        descripcion: e.descripcion,
        tipoImpuesto: e.tipoImpuesto,
        controlarcentrocostos: e.controlarcentrocostos,
      })}
    />
  )
}
